import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;

  @media (min-width: ${device.tablet}) {
    margin-bottom: 48px;
    gap: 16px;
  }
`;

export const Title = styled.div`
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.36px;

  @media (min-width: ${device.tablet}) {
    font-size: 28px;
  }
`;

export const Description = styled.div`
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;
